import React, { useEffect, useState } from "react";
// import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { getTaxes } from "../../api/TaxService";
export default function CategoryForm({
  onSubmit,
  loading = false,
  isEdit = false,
  backendErrors = {},
  initialData = {},
}) {
  const navigate = useNavigate();
  const initialState = {
    name: "",
    tagline: "",
    description: "",
    coverImage: "",
    hsnCode: "",
    taxApplied: false,
    taxId: "",

    // SEO
    metaTitle: "",
    metaKeywords: "",
    metaDescription: "",
  };
  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [taxes, setTaxes] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  /* =========================
      AUTO FILL EDIT DATA
  ========================= */
  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      setFormData({
        name: initialData.name || "",
        tagline: initialData.tagline || "",
        description: initialData.description || "",
        coverImage: initialData.coverImage || "",
        hsnCode: initialData.hsnCode || "",
        taxApplied: initialData.taxApplied || false,
        taxId: initialData.taxId || "",
        metaTitle: initialData.metaTitle || "",
        metaKeywords: Array.isArray(initialData.metaKeywords)
          ? initialData.metaKeywords.join(", ")
          : initialData.metaKeywords || "",
        metaDescription: initialData.metaDescription || "",
      });
    }
  }, [initialData]);
  /* =========================
      VALIDATION
  ========================= */
  // const validationSchema = Yup.object({
  //   name: Yup.string()
  //     .trim()
  //     .max(50, "Category name cannot exceed 50 characters")
  //     .required("Category name is required"),
  //   tagline: Yup.string()
  //     .required("Tagline is required"),
  //   description: Yup.string()
  //     .required("Description is required"),
  //   metaTitle: Yup.string()
  //     .required("Meta title is required"),
  //   metaKeywords: Yup.string()
  //     .required("Meta keywords are required"),
  //   metaDescription: Yup.string()
  //     .required("Meta description is required"),
  //   coverImage: Yup.mixed().test(
  //     "coverImage",
  //     "Category image is required",
  //     function (value) {
  //       if (isEdit) {
  //         return true;
  //       }
  //       return value ? true : false;
  //     }
  //   ),
  // });

  useEffect(() => {
    const fetchTaxes = async () => {
      try {
        const res = await getTaxes();

        setTaxes(res?.data || []);
      } catch (error) {
        console.error("Failed to fetch taxes", error);
      }
    };

    fetchTaxes();
  }, []);
  /* =========================
      HANDLE CHANGE
  ========================= */
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    // IMAGE TO BASE64
    if (files && files[0]) {
      const file = files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({
          ...prev,
          [name]: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  /* =========================
      HANDLE SUBMIT
  ========================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // await validationSchema.validate(formData, {
      //   abortEarly: false,
      // });
      setErrors({});
      const payload = {
        name: formData.name,
        tagline: formData.tagline,
        description: formData.description,
        // BASE64 IMAGE
        coverImage: formData.coverImage,
        hsnCode: formData.hsnCode,
        taxApplied: formData.taxApplied,
        taxId: formData.taxId,
        metaTitle: formData.metaTitle,
        metaKeywords: formData.metaKeywords
          .split(",")
          .map((item) => item.trim())
          .filter(Boolean),
        metaDescription: formData.metaDescription,
      };
      const success = await onSubmit(payload);

      if (!success) {
        return;
      }

      setSuccessMessage(
        isEdit
          ? "Category Updated Successfully"
          : "Category Added Successfully",
      );

      setTimeout(() => {
        setSuccessMessage("");
        navigate("/categories");
      }, 1500);
    } catch (error) {
      console.log(error);
      if (error.inner) {
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
      }
    }
  };
  return (
    <div className="container-fluid p-4">
      <div className="card shadow border-0 p-4">
        <h3>{isEdit ? "Edit Category" : "Add Category"}</h3>
        {successMessage && (
          <div className="alert alert-success">{successMessage}</div>
        )}
        <form onSubmit={handleSubmit}>
          {/* CATEGORY NAME */}
          <div className="row h80">
            <div className="col-md-12">
              <label className="form-label">
                Category Name<span className="error">*</span>
              </label>
              <input
                type="text"
                name="name"
                maxLength={50}
                className="form-control"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                  }}
                >
                  {errors.name}
                </div>
              )}
              {!errors.name && backendErrors?.name && (
                <div className="invalid-feedback d-block error">
                  {backendErrors.name}
                </div>
              )}
            </div>
          </div>
          {/* TAGLINE */}
          <div className="row h80">
            <div className="col-md-12 ">
              <label className="form-label">
                Tagline<span className="error">*</span>
              </label>
              <input
                type="text"
                name="tagline"
                className="form-control"
                value={formData.tagline}
                onChange={handleChange}
              />
              {errors.tagline && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                  }}
                >
                  {errors.tagline}
                </div>
              )}
              {!errors.name && backendErrors?.name && (
                <div className="invalid-feedback d-block error">
                  {backendErrors.name}
                </div>
              )}
            </div>
          </div>
          {/* DESCRIPTION */}
          <div className="row h120 mb-2">
            <div className="col-md-12">
              <label className="form-label">
                Description<span className="error">*</span>
              </label>
              <textarea
                rows="4"
                name="description"
                className="form-control"
                value={formData.description}
                onChange={handleChange}
              />
              {errors.description && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                  }}
                >
                  {errors.description}
                </div>
              )}
              {!errors.description && backendErrors?.description && (
                <div className="invalid-feedback d-block error">
                  {backendErrors.description}
                </div>
              )}
            </div>
          </div>
          <div className="row h80">
            <div className="col-md-6">
              <label className="form-label">Tax</label>

              <select
                name="taxId"
                className="form-select"
                value={formData.taxId}
                onChange={handleChange}
              >
                <option value="">Select Tax</option>

                {taxes.map((tax) => (
                  <option key={tax._id} value={tax._id}>
                    {tax._id}
                  </option>
                ))}
              </select>

              {backendErrors?.taxId && (
                <div className="invalid-feedback d-block error">
                  {backendErrors.taxId}
                </div>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label">Tax Applied</label>

              <select
                name="taxApplied"
                className="form-control"
                value={formData.taxApplied}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    taxApplied: e.target.value === "true",
                  }))
                }
              >
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </select>
            </div>
          </div>

          <div className="row h80">
            <div className="col-md-6">
              <label className="form-label">HSN Code</label>
              <input
                type="text"
                name="hsnCode"
                className="form-control"
                value={formData.hsnCode}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6 " style={{ minHeight: "85px" }}>
              <label className="form-label">
                Category Image<span className="error">*</span>
              </label>
              <input
                type="file"
                name="coverImage"
                className="form-control"
                accept="image/*"
                onChange={handleChange}
              />
              {errors.coverImage && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                  }}
                >
                  {errors.coverImage}
                </div>
              )}
              {!errors.coverImage && backendErrors?.coverImage && (
                <div className="invalid-feedback d-block error">
                  {backendErrors.coverImage}
                </div>
              )}
            </div>
          </div>
          {/* SEO */}
          <h5 className="col-md-12 p-0">SEO Data</h5>
          {/* META TITLE */}
          <div className="row h80">
            <div className="col-md-12" style={{ minHeight: "85px" }}>
              <label className="form-label">
                Meta Title<span className="error">*</span>
              </label>
              <input
                type="text"
                name="metaTitle"
                className="form-control"
                value={formData.metaTitle}
                onChange={handleChange}
              />
              {errors.metaTitle && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                  }}
                >
                  {errors.metaTitle}
                </div>
              )}
              {!errors.metaTitle && backendErrors?.metaTitle && (
                <div className="invalid-feedback d-block error">
                  {backendErrors.metaTitle}
                </div>
              )}
            </div>
          </div>
          {/* META KEYWORDS */}
          <div className="row h80">
            <div className="col-md-12" style={{ minHeight: "85px" }}>
              <label className="form-label">
                Meta Keywords<span className="error">*</span>
              </label>
              <input
                type="text"
                name="metaKeywords"
                className="form-control"
                value={formData.metaKeywords}
                onChange={handleChange}
                placeholder="seo, category, wooden"
              />
              {errors.metaKeywords && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                  }}
                >
                  {errors.metaKeywords}
                </div>
              )}
              {!errors.metaKeywords && backendErrors?.metaKeywords && (
                <div className="invalid-feedback d-block error">
                  {backendErrors.metaKeywords}
                </div>
              )}
            </div>
          </div>
          {/* META DESCRIPTION */}
          <div className="row h120">
            <div className="col-md-12" style={{ minHeight: "160px" }}>
              <label className="form-label">
                Meta Description<span className="error">*</span>
              </label>
              <textarea
                rows="4"
                name="metaDescription"
                className="form-control"
                value={formData.metaDescription}
                onChange={handleChange}
              />
              {errors.metaDescription && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                  }}
                >
                  {errors.metaDescription}
                </div>
              )}
              {!errors.metaDescription && backendErrors?.metaDescription && (
                <div className="invalid-feedback d-block error">
                  {backendErrors.metaDescription}
                </div>
              )}
            </div>
          </div>
          {/* BUTTONS */}
          <div className="d-flex justify-content-end gap-2 mt-3">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? "Submitting..." : isEdit ? "Update" : "Submit"}
            </button>

            <button
              type="button"
              className="btn"
              style={{ backgroundColor: "#032B4D", color: "#fff" }}
              onClick={() => navigate("/Category")}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
